import { Box, Icon, Typography } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const ACConfigHeader = ({ deleteMutate, id }) => {
  const navigate = useNavigate()

  const handleClose = () => {
    deleteMutate(id)
    navigate('/app/appraisal-cycle')
  }
  return (
    <Box
      sx={{
        width: '100%',
        height: 75,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: 'white.main',
        borderBottom: '1px solid',
        borderBottomColor: 'gray-line.main',
        position: 'sticky',
        top: 0,
        zIndex: 999,
        px: 3,
      }}
    >
      <Typography variant="h4" fontWeight={700}>
        Create new appraisal
      </Typography>
      <Icon onClick={handleClose} sx={{ fontSize: 25, cursor: 'pointer' }}>
        close
      </Icon>
    </Box>
  )
}

export default ACConfigHeader
